var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAction',[_c('SecondaryButton',{attrs:{"loading":_vm.isLoading,"textColor":"#0965dc"},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}},[_c('v-img',{staticClass:"mb-1",attrs:{"height":"30px","contain":"","src":_vm.icon}}),_vm._v(" Verify ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }